import React from 'react';
import { Container } from '../../components';
import styles from './design-quote.module.css';

export default function DesignQuote() {
  return (
    <div className={styles.root}>
      <Container>
        <p className={styles.text}>
          The first opinion is always remembered. Our mission is to arouse
          interest with the eyes in the first seconds, and then conquer with
          ease of use. Do you want to know the whole way to achieve the goal?
        </p>
      </Container>
    </div>
  );
}
